import { SharedParams } from './shared-params.const';

// Exam 5003
const ExamService = '/exam-management';

// Controllers
const ExamController = `${ExamService}/exams`;
const QuestionController = `${ExamService}/questions`;
const TraineeAnswerController = `${ExamService}/trainee-answers`;

export const ExamManagementService = {
    Exam: {
      Exams: ExamController,
      ExamById: (examId)=> `${ExamController}/${examId}`,
      IncompleteExamsPerCourse: (courseId) => `${ExamController}/${courseId}/incomplete-exams`,
      GetCourseExamResult: `${ExamController}/result`,
      GetTakenExam: (examId) => `${ExamController}/${examId}/exam-taken`,
      CourseExamAttempts: (examId, referenceId, referenceType) => `${ExamController}/${examId}/exam-attempts/${referenceType}/${referenceId}`,
      SetTraineeAnswerPerExam: (examId, traineeId) => `${ExamController}/${examId}/trainees/${traineeId}/answer`,
      TrainingPlan: (trainingPlanId) => `${ExamController}/training-plan/${trainingPlanId}`,
      TrainingPlanExamResult: (trainingPlanId) => `${ExamController}/training-plan/${trainingPlanId}/result`
    },
    Question: {
      Questions: QuestionController,
      UpdateExamQuestion: (examId, questionId) => `${QuestionController}/${examId}/questions/${questionId}`,
      UploadingAssignment: (questionId) => `${QuestionController}/${questionId}/${SharedParams.Uploading}-assignment`,
      DeleteQuestionFile: (fileId) => `${QuestionController}/${fileId}/question-file`,
    },
    TraineeAnswer: {
      TraineeAnswers: TraineeAnswerController,
      UploadingTraineeAssignment: (questionId) => `${TraineeAnswerController}/${questionId}/${SharedParams.Uploading}-trainee-assignment`,
      DeleteTraineeAnswerFile: (fileId) => `${TraineeAnswerController}/${fileId}/trainee-Answer-file`,
    },
};
